// MODE reflects the --mode passed to vite (development/qa/production), which is
// what the deploy workflow varies per environment. Sentry's `environment` is
// keyed off it, so events segment by deploy target rather than by NODE_ENV.
export const MODE = import.meta.env.MODE;

export const SENTRY_DSN = import.meta.env.SEATERS_APP_PUBLIC_SENTRY_DSN;

// vite's command, not NODE_ENV; MODE can't split `dev:qa` from `build:qa`.
export const IS_DEV_SERVER = import.meta.env.SEATERS_IS_DEPLOYED !== true;

// Opt Sentry back in from a dev server via a gitignored .env.local.
export const SENTRY_DEV_ENABLED = import.meta.env.SEATERS_SENTRY_DEV === 'true';
